import api from "../../api/index";
import config from "../../../static/config.json";

// 通用 Module
const state = {
  search: "", // 展品展馆搜索
  searchBy: "", // 展品输入框搜索
};
const mutations = {
  setSearchBy(state, data) {
    state.searchBy = data;
  },
  setSearch(state, data) {
    state.search = data;
  },
};
const getters = {
  getSearch: state => {
    return state.search;
  },
  getSearchBy: state => {
    return state.searchBy;
  },
};
const actions = {
  getUrlQuery({ rootGetters }) {
    // 获取url中的参数
    return new Promise((resolve, reject) => {
      const query = router.history.current.query;
      console.log(query);
      resolve(query);
    });
  },
  getUserInfoById({ commit, rootState }, id) {
    // 根据id获取用户详细信息；
    return new Promise((resolve, reject) => {
      api.get(`/api/userInfo/GetDetail?userid=${id}`).then(data => {
        if (data.status === 200 && data.data) {
          commit(
            "setUserInfoDetails",
            {
              userInfoDetails: data.data,
            },
            {
              root: true,
            }
          );
          localStorage.setItem("userInfoDetails", data.data);
          resolve(data.data);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
  getLiveInfoByRoomidNew({ commit, rootState, dispatch }, id) {
    // 根据roomid获取主办的信息
    return new Promise((resolve, reject) => {
      api.get(`${config.https.liveApi}/api/v1/liveroom/short?roomId=${id}`, rootState.header).then(({ data }) => {
        if (data && data.result) {
          commit("setRoomInfo", data.data, {
            root: true,
          });
          commit("setRoomId", data.data.roomId, {
            root: true,
          });
          commit("setExhibitionId", data.data.exhibitionId, {
            root: true,
          });
          commit("setLiveCode", data.data.liveState, {
            // 直播状态
            root: true,
          });
          // commit('setOpenLiveInfo', {
          //   hasOpenLiveCode: data.data.hasOpenLiveCode,
          //   hasOpenLive: data.data.hasOpenLive,
          //   hasOpenLiveMsg: data.data.hasOpenLiveMsg,
          // }, {
          //   root: true
          // });
          dispatch("getExhibitionInfo", data.data.exhibitionId); // 通过roomId获取展会信息
          dispatch("live/getLiveUrl", data.data.roomId, {
            root: true,
          }); // 通过roomId获取直播地址
          resolve(data.data);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
  getExhibitionInfo({ commit, rootState }, id) {
    //获取展会信息
    api.get(`${config.https.liveApi}/api/v1/exhibition/info-hsfollow?exhibitionId=${id}`, rootState.header).then(({ data }) => {
      if (data && data.result) {
        commit("setExhibitionInfo", data.data, {
          root: true,
        });
      }
    });
  },
  async getExhibitionInfoAndReturn({ dispatch, commit }, id) {
    let query = `#graphql
      query($id:Guid!){
        exhibition(id:$id){
        address
        banner
        banners(position: "show.page.home") {
          covers #封面 多个用;隔开
          content #内容
          enabledCountdown #是否启用倒计时
          exhibitionId #展会Id
          url #链接
          endAt
          createAt
          showIndex
        }
        city
        commentCount
        coordinate
        country
        createAt
        endDate
        followCount
        hallName
        helpMoney
        hallPanorama
        host{
          address
          createAt
          id
          isDeleted
          linkName
          logo
          name
          phone
          remark
          shortName
          updateAt
        }
        id
        industry
        isDeleted
        logo
        name
        nameEn
        province
        remark
        shareCount
        shortName
        shortNameEn
        startData
        talkCount
        updateAt
        userCount
        video
        viewCount
        organization
      }
    }`;
    let body = {
      queryName: "getExhibitionInfoAndReturn",
      query: query,
      variables: {
        id: id,
      },
    };
    let { data } = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    return new Promise((resolve, reject) => {
      if (data.exhibition) {
        commit("setExhibitionInfo", data.exhibition, {
          root: true,
        });
        resolve(data.exhibition);
      } else {
        resolve(false);
      }
    });
  },
  getCheck({ rootState }, opt) {
    // 检查用户是否关注该展会
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/exhibition/follow?exhibitionId=${opt.ExhibitionId}&userId=${opt.UserId}`, rootState.header).then(({ data }) => {
        if (data) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
  follow({ rootState }, opt) {
    // 关注
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/exhibition/follow`, opt, rootState.header).then(({ data }) => {
        if (data) {
          resolve(data);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
  cancelFollow({ rootState }, opt) {
    // 取消关注
    return new Promise((resolve, reject) => {
      api
        .delete(`${config.https.api}/api/v1/exhibition/follow`, {
          data: opt,
          ...rootState.header,
        })
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        });
    }).catch(err => {
      console.log(err);
    });
  },
  // 语言包
  getLang({ rootState }) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/liveroomlangs/all`, rootState.header).then(data => {
        if (data.status === 200 && data.data) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  // 语言字幕
  getLangSubtitle({ commit, rootState }, req) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.liveApi}/api/v1/livetranslate/livews/parameter-sign`, req, rootState.header).then(data => {
        if (data.status === 200 && data.data) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  //直播点赞
  likeTo({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v1/liveroom/like`, opt, rootState.header).then(({ data }) => {
        if (data) {
          resolve(data);
        } else {
          resolve(false);
        }
      });
    }).catch(err => {
      console.log(err);
    });
  },
  // 省份获取地区
  getRegionsByProvince({ rootState }, name) {
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/api/v1/region/belonging-to?name=${name}`, rootState.header).then(data => {
        if (data.status === 200 && data.data) {
          resolve(data.data);
        } else {
          resolve(false);
        }
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  // // 获取观众自定义表单
  // getCustomForm({
  //   rootState
  // },opt) {
  //   return new Promise((resolve, reject) => {
  //     api.get(`${config.https.api}/api/v3/form?itemId=${opt.id}&formType=${opt.type}`,rootState.header).then(data => {
  //       if (data.status === 200 && data.data && data.data.items) {
  //         data.data.items.map(c=>{
  //           if(c.attributes){
  //             c.attributes = JSON.parse(c.attributes)
  //           }
  //         })
  //         resolve(data.data);
  //       } else {
  //         resolve(false)
  //       }
  //     });
  //   }).catch(err => {
  //     resolve(false)
  //     console.log(err);
  //   });
  // },
  // 获取观众自定义表单
  async getCustomForm({ rootState, dispatch }, opt) {
    let query = `
          query($itemId: String!,$formType: String!){
          getForm(itemId: $itemId, formType: $formType){
              id
              items{
              attributes
              childrens{
                  attributes
                  defaultValue
                  description
                  formId
                  id
                  label
                  parentCount
                  parentId
                  showIndex
                  tagType
              }
              defaultValue
              description
              formId
              id
              label
              parentCount
              parentId
              showIndex
              tagType
              }
          }
          }
      `;
    let body = {
      query: query,
      variables: {
        itemId: opt.itemId,
        formType: opt.formType,
      },
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    return new Promise((resolve, reject) => {
      if (data.data) {
        resolve(data.data.getForm);
      } else {
        resolve(false);
      }
    });
  },
  // 获取展馆列表
  async getHallList({ rootState, dispatch }, opt) {
    let query = `
        query($exhibitionId: Guid!){
          getAllExHall(exhibitionId: $exhibitionId){
            id
            createAt
            description
            exhibitionId
            id
            isFile
            name
            nameEn
            shortName
            shortNameEn
            showIndex
          }
        }
    `;
    let body = {
      query: query,
      variables: {
        exhibitionId: rootState.exhibitionId,
      },
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    let res = JSON.parse(JSON.stringify(data.data.getAllExHall));
    // console.log(data,'data')
    return new Promise((resolve, reject) => {
      if (res) {
        resolve(res);
      } else {
        resolve(false);
      }
    }).catch(err => {
      resolve(false);
    });
  },
  // 添加自定义表单数据
  addCustomForm({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v3/formwrite`, opt, rootState.header).then(data => {
        resolve(data.data);
        console.log(data, "-----");
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  // 获取观众自定义表单数据
  async getUserCustomForm({ rootState, dispatch }, opt) {
    let query = `
        query($itemId: String!,$formType: String!,$userId: String!){
          getFormWrite(itemId: $itemId,formType: $formType,userId: $userId,){
            itemId
            items{
              childrens{
                createAt
                id
                label
                parentId
                tagType
                value
                writeId
              }
              createAt
              id
              label
              parentId
              tagType
              value
              writeId
            }
            
          }
        }
      `;
    let body = {
      query: query,
      variables: {
        itemId: opt.id,
        formType: opt.type,
        userId: opt.userId,
      },
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    console.log(data, "自定义数据");
    let res = JSON.parse(JSON.stringify(data.data.getFormWrite));
    return new Promise((resolve, reject) => {
      if (res) {
        resolve(res.items);
      } else {
        resolve([]);
      }
      // api.get(`${config.https.api}/api/v3/formwrite/by?itemId=${opt.id}&formType=${opt.type}&userId=${opt.userId}`,rootState.header).then(data => {
      //   if (data.status === 200 && data.data) {
      //     resolve(data.data.items);
      //   } else {
      //     resolve([])
      //   }
      // });
    }).catch(err => {
      resolve([]);
      console.log(err);
    });
  },
  async getUserAdvisorySetting({ rootState, rootGetters, dispatch, commit }) {
    let query = `
    {
      inMemberQuery {
        advisoryDayTotal(exhibitionId: "${rootGetters.getExhibitionId}",userId:"${rootState.userInfo.userId}") {
          userId
          appointmentDayNumber
          enquiryDayNumber
          agroaDayNumber
        }
      }
    }
    `;
    let body = {
      query: query,
      variables: {},
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    // console.log(data,'调用个人的次数')
    return new Promise((resolve, reject) => {
      if (data.data) {
        let res = JSON.parse(JSON.stringify(data.data.inMemberQuery.advisoryDayTotal));
        // console.log(res,'个人的次数')
        if (res) {
          commit("setMyAdvisorySetting", res, {
            root: true,
          });
          resolve(res);
        } else {
          reject("");
        }
      } else {
        reject("");
      }
    });
  },
  // 展商注册
  addExApply({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v3/applyexhibitor`, opt, rootState.header).then(data => {
        resolve(data.data);
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  // ip 添加访问记录
  addViewLikeIp({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v3/ipactioncount`, opt, rootState.header).then(data => {
        resolve(data.data);
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  // ip 添加访问记录
  addViewLikeIpByCountry({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      api.post(`${config.https.api}/api/v3/ipactioncount/country`, opt, rootState.header).then(data => {
        resolve(data.data);
      });
    }).catch(err => {
      resolve(false);
      console.log(err);
    });
  },
  // 添加浏览记录（主要作用展会访问量）
  addAllView({ rootState, commit }, opt) {
    return new Promise((resolve, reject) => {
      api
        .post(`${config.https.api}/api/v3/addview`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  getShorturl({ rootState, commit }, url) {
    // 获取短链接
    return new Promise((resolve, reject) => {
      api.get(`${config.https.api}/synair/shorturl/convert?url=` + url, rootState.header).then(
        res => {
          if (res.status === 200) {
            resolve(res.data.Data);
          } else {
            reject(res.data.Data);
          }
        },
        err => {
          reject(err);
        }
      );
    });
  },
  async getBannerByGraphal({ rootState, dispatch }, type) {
    let query = ` {
        bannerQuery {
            by(
                exhibitionId: "${rootState.exhibitionId}"
                position: "${type}"
            ) {
                name
                nameEn
                content
                covers
                enabledCountdown
                endAt
                exhibitionId
                position
                showIndex
                url
            } 
        } 
    }
    `;
    let body = {
      query: query,
    };
    let data = await dispatch("en/graphqlPostByZXS", body, {
      root: true,
    });
    return new Promise((resolve, reject) => {
      if (data.data) {
        resolve(data.data);
      } else {
        resolve(false);
      }
    });
  },
  getAnnouncement({ rootState }, opt) {
    // 公告
    return new Promise((resolve, reject) => {
      api
        .post(`${rootState.api.api}/api/v3/announcement/query`, opt, rootState.header)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
};
export default {
  state,
  actions,
  mutations,
  getters,
};
